import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ProfilePicture from "../UserProfile/ProfilePicture";
import {
  doc,
  getDoc,
  serverTimestamp,
  updateDoc,
  writeBatch,
} from "firebase/firestore";
import { db } from "../FirebaseConfig";

import formatTimestampForNotification from "../lib/formatTimestampForNotification";
import { useFriendActions } from "../hooks/user/useFriendActions";
import useModalStore from "../StatesStore/ModalStore";
import useNotification from "../hooks/useNotification";

function NewFriendRequest({
  notification,
  message,
  route,
  firstUserData,
  user,
}) {
  const navigate = useNavigate();
  const [isSeen, setIsSeen] = useState(notification.seen);
  const [isRecipientOnline, setIsRecipientOnline] = useState(false);
  const {
    requestList,
    pendingList,
    activeList,
    handleFriendAction,
    loading,
  } = useFriendActions(user);
  const { deleteNotification } = useNotification();

  const { openModal } = useModalStore();

  const handleClick = () => {
    openModal("SignInModal", "", "");
  };
  const handleNavigate = async () => {
    try {
      // Navigate to the dynamic route
      navigate(route);

      // Update the 'seen' attribute to true in Firestore
      if (!isSeen) {
        setIsSeen(true);
        const notificationRef = doc(
          db,
          "users",
          user?.uid,
          "notifications",
          notification.notificationId
        );
        await updateDoc(notificationRef, { seen: true });
      }
    } catch (error) {
      console.error("Error updating notification: ", error);
    }
  };
  const denyRequest = async () => {
    try {
      // Start a batched write to perform multiple updates atomically
      const batch = writeBatch(db);

      // Reference to the connections subcollection for both the sender and receiver
      const senderConnectionRef = doc(
        db,
        "users",
        firstUserData?.userId,
        "connections",
        user?.uid
      );
      const receiverConnectionRef = doc(
        db,
        "users",
        user?.uid,
        "connections",
        firstUserData?.userId
      );

      batch.delete(senderConnectionRef);
      batch.delete(receiverConnectionRef);

      // Commit the batched write
      await batch.commit();
      // console.log("receiverId " + receiverId + "and senderId from handle accept req ", senderId);

      await deleteNotification({
        userId: user?.uid,
        id: firstUserData?.userId,
        type: "friendRequest",
        by: "user",
      });

      console.log("Friend request denyed successfully!");
    } catch (error) {
      console.error("Error accepting connection request: ", error);
    }
  };
  return (
    <li
      onClick={handleNavigate}
      className="border-bottom"
      style={{
        padding: "0.625rem 1rem",
        cursor: "pointer",
        backgroundColor: !isSeen ? "#EFF6FF" : "transparent",
      }}
    >
      <div
        className={`d-flex my-0`}
        style={{ display: "inline-flex", gap: "12px", cursor: "pointer" }}
      >
        <div
          style={{ height: "50px", width: "50px" }}
          className={`avatar text-center d-inline-block ${
            isRecipientOnline ? "status-online" : " "
          }`}
        >
          <ProfilePicture userData={firstUserData} />
        </div>
        <div
          className={`w-100 rounded-2 p-0 d-flex align-items-center justify-content-center `}
        >
          <div
            className="w-100 d-flex gap-2 flex-column justify-content-between p-0"
            style={{ fontFamily: "Inter", color: "#676A79", fontWeight: 500 }}
          >
            <div className="d-flex flex-grow-1">
              <p className="small mb-0  d-flex flex-column">
                <span
                  style={{
                    fontSize: "16px",
                    color: "#000000",
                    fontWeight: 500,
                  }}
                >
                  {firstUserData?.userName}
                </span>{" "}
                <span style={{ fontSize: "15px" }}>{message}</span>
              </p>
            </div>

            {/* Accept or Decline Buttons */}
            <div className="d-flex gap-2">
              <button
                className="btn btn-primary btn-sm rounded-2"
                onClick={(event) => {
                  event.stopPropagation();
                  if (!user) {
                    handleClick();
                  } else if (!user?.emailVerified) {
                    openModal("VerifyEmailModal", "", {
                      userName: user?.displayName,
                      email: user?.email,
                    });
                  } else if (user) {
                    handleFriendAction(firstUserData?.userId, user);
                  }
                }}
              >
                {activeList && activeList.includes(firstUserData?.userId)
                  ? " Unfriend"
                  : pendingList && pendingList.includes(firstUserData?.userId)
                  ? " Accept"
                  : " Add Friend"}
              </button>
              <button
                className="btn border btn-sm rounded-2"
                style={{ color: "#696F8C" }}
                onClick={(event) => {
                  event.stopPropagation();
                  denyRequest();
                }}
              >
                Deny
              </button>
            </div>
            <div className="small" style={{ fontSize: "12px" }}>
              {formatTimestampForNotification(notification.timestamp)}
            </div>
          </div>
        </div>
      </div>
    </li>
  );
}

export default NewFriendRequest;
